<div class="onboarding-card-title" translate>ai-exam-onboarding.comfort.title</div>
<p class="onboarding-card-subtitle" translate>ai-exam-onboarding.comfort.subtitle</p>

<div class="reassurance">
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8s2.91 6.5 6.5 6.5 6.5-2.91 6.5-6.5S11.59 1.5 8 1.5zm.75 9.75h-1.5v-4.5h1.5v4.5zm0-6h-1.5v-1.5h1.5v1.5z" fill="currentColor"/>
    </svg>
    <span translate>ai-exam-onboarding.comfort.reassurance</span>
</div>

<div class="chips-label" translate>ai-exam-onboarding.comfort.chips-label</div>
<div class="chips">
    @for (chip of chips; track chip.id) {
    <button type="button" class="chip" [class.selected]="isSelected(chip.id)"
        (click)="toggleChip(chip.id)">
        <span class="chip-icon">{{ chip.icon }}</span>
        <span translate>{{ chip.labelKey }}</span>
    </button>
    }
</div>

<div class="chips-label" translate>ai-exam-onboarding.comfort.free-text-label</div>
<textarea class="free-text" [ngModel]="freeText()" (ngModelChange)="onFreeTextChange($event)"
    [placeholder]="'ai-exam-onboarding.comfort.free-text-placeholder' | translate"></textarea>

<div class="onboarding-actions">
    <button type="button" class="onboarding-btn-back" (click)="back.emit()">
        ← <span translate>ai-exam-onboarding.back</span>
    </button>
    <button type="button" class="onboarding-btn-primary flex-1" (click)="onContinue()">
        <span translate>ai-exam-onboarding.continue</span>
    </button>
</div>
